<template>
    <div class="adBack">
        <img class="img" src="../../assets/ad/id1.png">
        <img class="img" src="../../assets/ad/id2.png">
        <img class="img" src="../../assets/ad/id3.png">
        <img class="img" src="../../assets/ad/id4.png">
        <img class="img" src="../../assets/ad/id5.png">
        <img class="img" src="../../assets/ad/id6.png">
    </div>
</template>

<script>
    export default {
        name: "LightID"
    }
</script>

<style scoped lang="less">
    .adBack{
        background: #ffffff;
        min-height: 100%;
        .img{
            width: 100%;
            height: 100%;
            margin-top: -1vh;
        }
    }
    .footer{
        height: 20vh;
        .footer-button{
            background: #333;
            width: 70vw;
            height: 13vw;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
        }
    }
</style>
